(function () {
    'use strict';

    var module = angular.module('uwAgenda.ringfoon');
    module.directive('ringfoonInfo', [
        '$rootScope', 
        '$sce', 
        'SharedAgendaService', 
        'SharedAgendaBroadcast', 
        'ProtocolFilter',
        'ExternalLocationService',
        '$state', 
        RingfoonInfoFn]);

    /* Ringfoon info panel directive */
    function RingfoonInfoFn(
        $rootScope, 
        $sce, 
        SharedAgendaService, 
        SharedAgendaBroadcast, 
        ProtocolFilter, 
        ExternalLocationService,
        $state) {

        var directive = {
            restrict: 'E',
            replace: false,
            templateUrl: '/app/ringfoon/templates/ringfoon-info.template.html',
            link: link
        };
        return directive;


        function link(scope, element) {
            // search value for protocol search
            scope.search = { value: null };
            
            // list of client protocols
            scope.protocols = [];
            
            // list of active protocols, needed for the current view
            scope.activeProtocols = [];

            // currently selected client object
            scope.client = {};

            scope.isRingfoonAdmin = $rootScope.isRingfoonAdmin;     
            
            scope.externalLocations = [];

            activate();

            // listen
            function listen() {
                // listen on changed client
                var listener = scope.$on(SharedAgendaBroadcast.AgendaOwnerLoaded, function () {
                    setDataForInfoPanel();
                });

                var stateChangeSuccessListener = $rootScope.$on('$stateChangeSuccess', function () {         
                    
                    var currentStateName = $state.current.name;
                    var currentAgenda = SharedAgendaService.data.currentAgenda;
    
                    scope.activeProtocols = [];
                    var len = currentAgenda.owner.protocols.length;
                    for (var i=0; i < len; i++) {
    
                        // only show this protocol when the user is in the appointment form  
                        if (currentAgenda.owner.protocols[i][ProtocolFilter.ShowOnAppointmentView] && 
                            currentStateName === 'Home.Agenda_Appointment') {
                                                        
                            scope.activeProtocols.push(currentAgenda.owner.protocols[i]);
                        }
                    }                
                });

                scope.$on("$destroy", function () {
                    if (listener) {
                        listener();
                        listener = null;
                    }

                    if (stateChangeSuccessListener) {
                        stateChangeSuccessListener();
                    }
                });
            }

            /* load work */
            function activate() {
                // set vm variables
                setDataForInfoPanel();

                // listen to event
                listen();
            }

            // set data for info panel
            function setDataForInfoPanel() {
                // protocols of current selected user/agenda
                if (SharedAgendaService.data.currentAgenda.owner.protocols) {
                    scope.protocols = SharedAgendaService.data.currentAgenda.owner.protocols;

                    // trust
                    scope.protocols.forEach(function (item) {
                        if (item && item.content) {
                            item.contentTrusted = $sce.trustAsHtml(item.content);
                        } //if
                    });

                    // filter protocols for sidebar
                    if (scope.protocols && scope.protocols.length > 0) {
                        scope.protocols = scope.protocols.filter(filterProtocols);
                    }
                }

                scope.search.value = null;
                scope.client = SharedAgendaService.data.client;

                ExternalLocationService.getAllExternalLocations(SharedAgendaService.data.currentAgenda.id)
                        .then(function(externalLocations) {
                            scope.externalLocations = externalLocations;
                        });
            }

            // only protocols for sidebar
            function filterProtocols(obj) {
                return obj[ProtocolFilter.ShowInSidebar] === true;
            }

        } // link



    }
})();